import * as React from "react";

export const IconPlus = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="14px" height="14px" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.66699 0C7.12723 9.66013e-08 7.5 0.373747 7.5 0.833984L7.5 5.83398L12.5 5.83398C12.9602 5.83398 13.334 6.20675 13.334 6.66699C13.334 7.12723 12.9602 7.5 12.5 7.5L7.5 7.5L7.5 12.5C7.5 12.9602 7.12723 13.334 6.66699 13.334C6.20675 13.334 5.83398 12.9602 5.83398 12.5L5.83398 7.5L0.833984 7.5C0.373747 7.5 3.91352e-07 7.12723 0 6.66699C2.01176e-08 6.20675 0.373747 5.83398 0.833984 5.83398L5.83398 5.83398L5.83398 0.833984C5.83398 0.373747 6.20675 0 6.66699 0Z"
      fill={props?.color ?? "white"}
    />
  </svg>
);
